<template>
  <div class="card mb-5 mb-xxl-8" v-show="!isReady">
    <div class="card-body pb-0">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.user_list') }}</h3>
        </div>
        <div class="card-toolbar" v-if="store?.etat == 'active'">
          <button  v-if="$can('user_magasin_create')"  @click="openCreateModal" class="btn btn-sm btn-primary">{{ $t('button.add') }}</button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <table class="table align-middle table-row-bordered fs-6 gy-3 "  id="kt_datatable_store_user">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-100px">{{ $t('shop.user_lastname')}}</th>
              <th class="min-w-100px">{{ $t('shop.user_firstname')}}</th>
              <th class="min-w-100px">{{ $t('shop.user_role')}}</th>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
    <div class="modal fade" id="createModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog" >
        <form @submit.prevent="addUsersInStoreData" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('store.user.add') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              </div>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('store.user.label') }}</span>
                </label>
                <select name="user_id" class="form-select form-select-solid kt_select2"
                        data-control="select2"
                        :data-placeholder="$t('shop.user_placeholder')"
                        data-search="true" data-dropdown-parent="#createModal"
                        v-model="formCreateData.user_id" required   >
                  <option value="" selected></option>
                  <option  v-for="user in storeUsers" :key="user.id"
                           :value="user.id">{{ user.lastname }} {{ user.firstname }} </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" class="btn btn-sm btn-primary" >{{ $t('button.save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="container-xxl" v-show="isReady">
    <Loader />
  </div>
</template>

<script>
import {mapActions,mapGetters} from "vuex";
import {BASE_URL} from "@/services/api";
import Loader from "@/components/Loader.vue";

export default {
  name: "Users",
  components: { Loader },
  data(){
    return{
      formCreateData: {
        user_id : null,
      },
      formDeleteData: {
        id: null,
        row: null
      },
      isLoading: false,
      storeUsers: {},
      detailUser:{
        store_id: null,
        user_id: null
      },
      swailDeleteText : i18n.global.t("swal.store.user"),
      confirmButtonText : i18n.global.t('store.deleted'),
      store: {},
      isReady: false
    }

  },

  computed: {
    ...mapGetters('user',[
        'getUsers'
    ]),

  },
  async mounted(){
    this.isReady = true

    await this.fetchDatas();

    await this.loadUserStore()

    $(".kt_select2").select2()

    $('#kt_select2').select2({
      placeholder: "Selectionnez un magasinier"
    })

    $(".kt_select2").change((e) => {
      switch (e.target.name) {
        case 'user_id':
          this.formCreateData.user_id = e.target.value
          break;
        default:
          break;
      }
    })

    let response = await this.showStore(this.$route.params.id)
    this.store = response.data.store

    $(document).on("click", ".delete_btn" ,(e) => {
      if(this.store?.etat == 'active'){
        this.formDeleteData.id = e.target.getAttribute('data-id');
        Swal.fire({
          text: this.swailDeleteText,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: this.confirmButtonText,
          cancelButtonText: 'Annuler',
          customClass: {
            confirmButton: "btn btn-danger",
              cancelButton: 'btn btn-secondary'
          }
        }).then((result) => {
          if(result.isConfirmed){
            this.detailUser.user_id = this.formDeleteData.id
            this.detailUser.store_id = this.$route.params.id
            this.deleteDataUser()
          }
        })
      }
    })

    this.isReady = false
    // Le tableau a été initialisé caché (largeur 0) : on recalcule les colonnes visibles
    this.$nextTick(() => this.table?.columns.adjust().responsive.recalc())
  },
  methods: {
   ...mapActions('user', ['getUserStore','addUserStore', 'removeUserStore']),
   ...mapActions('store', ['showStore']),

    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token');

      this.table = $("#kt_datatable_store_user").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL+"/get/stores/"+this.$route.params.id+"/users/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data:  function ( d ) {

          }
        },
        columns: [{ data: "lastname" },{ data: "firstname" },{ data: "role" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<button class="btn btn-sm btn-light-primary"  style="font-size:13px; margin:3px; padding:3px" data-id="'+ e.id +'"  class="roleRow'+ l.row +'">' + t + "</button>";
            },
          },


          {
            width: "10%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {

              let render=""
              if(this.$can('user_magasin_delete')  ){
                render +='<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon" title="delete"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="delete_btn la la-trash"></i></a>'

              }
              return render

            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    openCreateModal(){
      $('#createModal').modal('toggle')
    },

    async loadUserStore(){
      let response = {}
      try {
        response = await this.getUserStore(this.$route.params.id)
        this.storeUsers = response.data.storeUsers
      }catch(e){
        window.toastr['error'](response.data.error)
      }
    },

    async addUsersInStoreData(){
      let data = {
        user_id: this.formCreateData.user_id,
         id : this.$route.params.id,
         status : 'actif'
      }
      let response = {}
      try{
        response = await this.addUserStore(data)
        this.isLoading = false
        window.toastr['success'](response.data.message)
        this.storeUsers = response.data.store_user
        this.table.ajax.reload()
        $('#createModal').modal('toggle')
        this.formCreateData = {
          user_id: '',

        }
        return true
      }catch(e){
        this.isLoading = false
        if(response && response.data){
          window.toastr['error'](response.data.error)
          return true
        }
      }
    },

    async deleteDataUser(){
      
      let response = {}
      try {
        response = await this.removeUserStore(this.detailUser)
         window.toastr['success'](response.data.message)
         let users_list = await this.getUserStore(this.$route.params.id)
        this.storeUsers = users_list.data.storeUsers
          this.table.ajax.reload()
      }catch(e){
         window.toastr['error'](response.data.error)
      }
    }
  }
}
</script>

<style scoped>

</style>
